module.exports = __webpack_public_path__ + "static/media/ZCL.e194b125.pdf";